import React from 'react'
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';


const Footer = () => {
    return (
        <div style={{ textAlign: "center", padding: "2rem", color: '#f1f1f1', fontWeight: 'bolder' }}>
            <h2>Developed by <a style={{ textDecoration: 'none', color:'orange' }} href='https://www.linkedin.com/in/prayas-banerjee/' target='_blank'>Prayas</a></h2>
        </div>
    )
}

export default Footer
